import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1C1917] text-[#FAF3E7] mt-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-7 md:py-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://customer-assets-lqy194kg.emergentagent.net/job_nityavastra-shop/artifacts/dirh3az1_Updated%20Logo%20Nityavastra.png"
                alt="Nityavastra"
                className="w-14 h-14 rounded-full"
              />
              <h3 className="font-serif text-3xl">Nityavastra<span className="text-[#D4A03A]">.</span></h3>
            </div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#D4A03A] mb-4">Sacred Weaves · Everyday Grace</p>
            <p className="text-sm text-[#FAF3E7]/70 leading-relaxed max-w-sm">
              Handcrafted heritage & everyday essentials — where tradition meets your home.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="uppercase text-xs tracking-[0.2em] font-semibold mb-3 text-[#D4A03A]">Shop</h4>
            <ul className="space-y-3 text-sm text-[#FAF3E7]/80">
              <li><Link to="/shop?category=sarees" className="hover:text-white">Sarees</Link></li>
              <li><Link to="/shop?category=daily-wear" className="hover:text-white">Daily Wear</Link></li>
              <li><Link to="/shop?category=home-essentials" className="hover:text-white">Home Essentials</Link></li>
              <li><Link to="/shop?tag=bestseller" className="hover:text-white">Bestsellers</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="uppercase text-xs tracking-[0.2em] font-semibold mb-3 text-[#D4A03A]">Help</h4>
            <ul className="grid grid-cols-1 gap-y-2 text-sm text-[#FAF3E7]/80 lg:grid-flow-col lg:grid-cols-2 lg:grid-rows-6 lg:gap-x-5">
              <li><Link to="/pages/about" className="hover:text-white" data-testid="footer-about">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link></li>
              <li><Link to="/pages/shipping-policy" className="hover:text-white" data-testid="footer-shipping">Shipping</Link></li>
              <li><Link to="/pages/return-policy" className="hover:text-white" data-testid="footer-returns">Returns</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/grievance-redressal" className="hover:text-white">Grievance Redressal</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Use</Link></li>
              <li><Link to="/cancellation-refund-policy" className="hover:text-white">Cancellation &amp; Refunds</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-white">Cookie Policy</Link></li>
              <li><button type="button" onClick={() => window.dispatchEvent(new Event("nv:open-cookie-preferences"))} className="hover:text-white">Cookie preferences</button></li>
              <li><Link to="/account?tab=orders" className="hover:text-white">Track Order</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="uppercase text-xs tracking-[0.2em] font-semibold mb-3 text-[#D4A03A]">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-[#FAF3E7]/80">
              <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /> Bhubaneswar, Kalyani Nagar Rd 751019</li>
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 shrink-0" /> <a href="tel:+918281037035" className="hover:text-white">+91 8281037035</a></li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 shrink-0" /> <a href="mailto:hello@nityavastra.com" className="hover:text-white">hello@nityavastra.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-[#FAF3E7]/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#FAF3E7]/60">
          <p>© 2026 Nityavastra. All rights reserved.</p>
          <p>Payments powered by Razorpay · Ships across India</p>
        </div>
      </div>
    </footer>
  );
}
